import React, { useContext, useEffect, useState } from "react";
import CardSection from "../../../../../../components/ui/card/CardSection";
import MolGrid, { Column } from "@moltech/molui/molgrid";
import Buttons from "../../../../../../components/ui/button/Buttons";
import { useAddPendingContractDepartmentsMutation, useDeletePendingContractDepartmentMutation, useLazyGetPendingContractDepartmentsAvailableQuery, useLazyGetPendingContractDepartmentsQuery } from "../../../../../../app/services/pendingContractAPI";
import { PendingContractContext } from "../../../../../../utils/context/PendingContractContext";
import ToastService from "../../../../../../services/toastService/ToastService";

const Departments = () => {

  const { pendingContractId } = useContext(PendingContractContext) || {};
  const [contractDepartmentsData, setContractDepartmentsData] = useState([]);
  const [contractDepartmentsAvailableData, setContractDepartmentsAvailableData] = useState([]);
  const [selectedCheckboxRows, setSelectedCheckboxRows] = useState([]);

  const [getPendingContractDepartmentsAvailable, {
    isFetching: isPendingContractDepartmentsAvailableFetching,
    isSuccess: isPendingContractDepartmentsAvailableFetched,
    data: PendingContractDepartmentsAvailableData,
  },] = useLazyGetPendingContractDepartmentsAvailableQuery();

  const [getPendingContractDepartments, {
    isFetching: isPendingContractDepartmentsFetching,
    isSuccess: isPendingContractDepartmentsFetched,
    data: PendingContractDepartmentsData,
  },] = useLazyGetPendingContractDepartmentsQuery();


  const [addPendingContractDepartments, {
    isSuccess: isPendingContractDepartmentsAdded,
    data: PendingContractDepartmentsaddData,
  },] = useAddPendingContractDepartmentsMutation();


  const [deletePendingContractDepartment, {
    isSuccess: deletePendingContractDepartmentFetching,
    data: deletePendingContractDepartmentData
  }] = useDeletePendingContractDepartmentMutation();


  useEffect(() => {
    if (pendingContractId) {
      getPendingContractDepartmentsAvailable(pendingContractId);
      getPendingContractDepartments({ plPendingContractKey: pendingContractId, plClientKey: 0 });
    }
  }, [pendingContractId, isPendingContractDepartmentsAdded, deletePendingContractDepartmentFetching]);

  useEffect(() => {
    if (!isPendingContractDepartmentsAvailableFetching && isPendingContractDepartmentsAvailableFetched && PendingContractDepartmentsAvailableData) {
      if (PendingContractDepartmentsAvailableData) {
        setContractDepartmentsAvailableData(PendingContractDepartmentsAvailableData);
      }
    }
  }, [isPendingContractDepartmentsAvailableFetching, isPendingContractDepartmentsAvailableFetched, PendingContractDepartmentsAvailableData])

  useEffect(() => {
    if (!isPendingContractDepartmentsFetching && isPendingContractDepartmentsFetched && PendingContractDepartmentsData) {
      if (PendingContractDepartmentsData) {
        setContractDepartmentsData(PendingContractDepartmentsData);
      }
    }
  }, [isPendingContractDepartmentsFetching, isPendingContractDepartmentsFetched, PendingContractDepartmentsData])

  useEffect(() => {
    if (isPendingContractDepartmentsAdded && PendingContractDepartmentsaddData) {
      if (PendingContractDepartmentsaddData) {
        ToastService.success(PendingContractDepartmentsaddData?.errorMessage);
        setSelectedCheckboxRows([]);
      }
    }
  }, [isPendingContractDepartmentsAdded, PendingContractDepartmentsaddData])

  useEffect(() => {
    if (deletePendingContractDepartmentFetching && deletePendingContractDepartmentData) {
      if (deletePendingContractDepartmentData) {
        ToastService.success(deletePendingContractDepartmentData?.errorMessage);
      }
    }
  }, [deletePendingContractDepartmentFetching, deletePendingContractDepartmentData])


  const handleAssignClick = () => {
    if (selectedCheckboxRows && selectedCheckboxRows.length > 0) {
      const departmentKeys = selectedCheckboxRows.map(row => row.lDepartmentKey).join(',');
      const request = {
        plPendingContractKey: pendingContractId,
        psDepartmentKeys: departmentKeys
      }
      addPendingContractDepartments(request);
    } else {
      ToastService.error("Please select at least one department to assign.");
    }
  }

  const handleAddRow = (rowData) => {
    if (rowData) {
      const request = {
        plPendingContractKey: pendingContractId,
        psDepartmentKeys: rowData?.lDepartmentKey.toString()
      }
      addPendingContractDepartments(request);
    }
  }

  const handleDeleteRow = (rowData) => {
    if (pendingContractId && rowData) {
      deletePendingContractDepartment({ plPendingContractKey: pendingContractId, plDepartmentKey: rowData?.lDepartmentKey });
    }
  }

  const getCtxMenuItems = (row) => {
    if (!row) return [];

    return [
      {
        label: "Remove",
        command: () => handleDeleteRow(row),
      },
    ];
  };

  const getCtxMenuItems1 = (row) => {
    if (!row) return [];
    return [
      {
        label: "Add",
        command: () => handleAddRow(row),
      },
    ];
  }

  return (
    <>
      <div className="row gap-4">
        <div className="scrollable-grid col-12">
          <CardSection cardTitle="Assigned Departments">
            <MolGrid
              value={contractDepartmentsData}
              grouping
              expandableRowGroups={true}
              paginator={false}
              scrollable
              scrollHeight="flex"
              filterDisplay="row"
              sortMode="single"
              showGridlines
              resizableColumns
              ctxMenuItems={getCtxMenuItems}
            >
              <Column
                field="sClientName1"
                header="Client"
                grouping
                sortable
                style={{ width: "50%" }}
              />
              <Column
                field="sDepartmentName"
                header="Department"
                grouping
                sortable
                style={{ width: "50%" }}
              />
            </MolGrid>
          </CardSection>
        </div>

        <div className="center-btn">
          <Buttons
            isIcon={true}
            iconClass="bxs:up-arrow"
            onClick={handleAssignClick}
            buttonTypeClassName="btn blue-btn"
            titleText="Assign Selected Items"
            isDisable={selectedCheckboxRows.length === 0}
          />
        </div>
        <div className="scrollable-grid col-12 available-department">
          <CardSection cardTitle="Available Departments">
            <MolGrid
              grouping
              value={contractDepartmentsAvailableData}
              expandableRowGroups={true}
              paginator={false}
              scrollable
              scrollHeight="flex"
              filterDisplay="row"
              sortMode="single"
              showGridlines
              resizableColumns
              ctxMenuItems={getCtxMenuItems1}
              selection={selectedCheckboxRows}
              onSelectionChange={(e) => setSelectedCheckboxRows(e.value)}
              dataKey="lDepartmentKey"
            >
              <Column
                selectionMode="multiple"
                bodyStyle={{ textAlign: "center" }}
              />
              <Column
                field="sClientName1"
                header="Client"
                grouping
                sortable
                style={{ width: "45%" }}
              />
              <Column
                field="sDepartmentName"
                header="Department"
                grouping
                sortable
                style={{ width: "45%" }}
              />
            </MolGrid>
          </CardSection>
        </div>
      </div>
    </>
  );
};

export default Departments;
